import { Flex } from "antd"
import { Text } from "~/components/Text"
import styles from "./index.css"

export const SectionTitle = ({
  number,
  title,
  optional = false,
}: {
  number: 1 | 2 | 3
  title: string
  optional?: boolean
}) => (
  <Flex
    component="span"
    align="center"
    gap={8}
  >
    <Flex
      component="span"
      className={styles.number}
      align="center"
      justify="center"
    >
      <Text
        size="s"
        color="inherit"
      >
        {number}
      </Text>
    </Flex>
    <Text
      size="m"
      strong
    >
      {title}
    </Text>
    {optional ? (
      <Text
        size="s"
        className={styles.optional}
      >
        非必填
      </Text>
    ) : null}
  </Flex>
)
